import type { EtlRollupStatus } from '../types/operations.types';

export const ROLLUP_STATUS_LABELS: Record<EtlRollupStatus, string> = {
  green: 'Green',
  yellow: 'Yellow',
  red: 'Red',
  no_data: 'No data',
};

export const ROLLUP_BAR_COLOURS: Record<EtlRollupStatus, string> = {
  green: 'bg-emerald-500 hover:bg-emerald-600',
  yellow: 'bg-amber-500 hover:bg-amber-600',
  red: 'bg-red-500 hover:bg-red-600',
  no_data: 'bg-gray-300 hover:bg-gray-400',
};

export const ROLLUP_STATUS_PILL_COLOURS: Record<EtlRollupStatus, string> = {
  green: 'bg-emerald-50 text-emerald-800 border-emerald-200',
  yellow: 'bg-amber-50 text-amber-900 border-amber-200',
  red: 'bg-red-50 text-red-800 border-red-200',
  no_data: 'bg-gray-100 text-gray-700 border-gray-200',
};

export function rollupStatusFromRawStatus(status: string | null | undefined): EtlRollupStatus {
  const value = (status ?? '').trim().toLowerCase();
  if (['fail', 'failed', 'failure', 'error', 'critical', 'critical_fail'].includes(value)) {
    return 'red';
  }
  if (['warn', 'warning'].includes(value)) {
    return 'yellow';
  }
  if (['pass', 'passed', 'ok', 'success', 'healthy'].includes(value)) {
    return 'green';
  }
  if (!value) {
    return 'no_data';
  }
  return 'yellow';
}

export function formatRollupTooltip(day: {
  date: string;
  counts: { red: number; yellow: number; green: number; total: number };
}): string {
  const { date, counts } = day;
  if (counts.total === 0) {
    return `${date} — no checks recorded`;
  }
  return `${date} — ${counts.red} red, ${counts.yellow} yellow, ${counts.green} green across all checks`;
}

export function formatNumber(value: number | null | undefined, digits = 2): string {
  if (value === null || value === undefined || Number.isNaN(value)) {
    return '—';
  }
  return value.toLocaleString(undefined, {
    minimumFractionDigits: 0,
    maximumFractionDigits: digits,
  });
}

export function formatPercent(value: number | null | undefined): string {
  if (value === null || value === undefined || Number.isNaN(value)) {
    return '—';
  }
  return `${formatNumber(value)}%`;
}
